export default __webpack_public_path__ + "static/media/dobbies.af510426.webp";